import React from "react";

type Props = {
  width: number;
  height: number;
};

export const IconGearSVG: React.FC<Props> = (props) => {
  const { width, height } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={`0 0 36.304 36.279`}
    >
      <g transform="translate(-1393.1 -1034.05)">
        <g transform="matrix(1, 0, 0, 1, 1393.1, 1034.05)">
          <path
            d="M1409.964,1065.828h2.577a1.95,1.95,0,0,0,1.965-1.544l.549-2.386.408-.14,2.08,1.276a1.932,1.932,0,0,0,2.488-.306l1.786-1.773a1.934,1.934,0,0,0,.306-2.488l-1.3-2.067.153-.383,2.386-.561a1.973,1.973,0,0,0,1.544-1.965v-2.526a1.96,1.96,0,0,0-1.544-1.965l-2.36-.574-.166-.408,1.3-2.067a1.935,1.935,0,0,0-.306-2.488l-1.786-1.786a1.944,1.944,0,0,0-2.475-.306l-2.08,1.276-.434-.166-.549-2.386a1.95,1.95,0,0,0-1.965-1.544h-2.577a1.95,1.95,0,0,0-1.965,1.544l-.561,2.386-.434.166-2.067-1.276a1.961,1.961,0,0,0-2.488.306l-1.773,1.786a1.92,1.92,0,0,0-.306,2.488l1.289,2.067-.153.408-2.361.574a1.96,1.96,0,0,0-1.544,1.965v2.526a1.973,1.973,0,0,0,1.544,1.965l2.386.561.14.383-1.288,2.067a1.919,1.919,0,0,0,.306,2.488l1.773,1.773a1.949,1.949,0,0,0,2.5.306l2.067-1.276.408.14.561,2.386A1.95,1.95,0,0,0,1409.964,1065.828Zm.2-1.99a.325.325,0,0,1-.37-.293l-.766-3.164a7.216,7.216,0,0,1-2.054-.842l-2.782,1.71a.334.334,0,0,1-.472-.064l-1.506-1.506a.352.352,0,0,1-.051-.472l1.71-2.756a9.289,9.289,0,0,1-.829-2.042l-3.164-.753a.325.325,0,0,1-.294-.37v-2.131c0-.23.077-.332.294-.37l3.151-.766a10.36,10.36,0,0,1,.817-2.054l-1.7-2.756a.371.371,0,0,1,.038-.5l1.519-1.48a.345.345,0,0,1,.485-.064l2.756,1.671a10.363,10.363,0,0,1,2.093-.842l.753-3.164a.325.325,0,0,1,.37-.294h2.169c.217,0,.332.089.357.294l.778,3.19a9.314,9.314,0,0,1,2.055.829l2.768-1.684a.361.361,0,0,1,.5.064l1.505,1.48a.358.358,0,0,1,.038.5l-1.7,2.756a9.658,9.658,0,0,1,.817,2.054l3.164.766a.319.319,0,0,1,.294.37v2.131a.333.333,0,0,1-.294.37l-3.177.753a8.7,8.7,0,0,1-.829,2.042l1.71,2.756a.339.339,0,0,1-.051.472l-1.493,1.506a.349.349,0,0,1-.485.064l-2.781-1.71a7.13,7.13,0,0,1-2.042.842l-.778,3.164c-.026.2-.14.293-.357.293Zm1.084-6.775a4.861,4.861,0,1,0-4.874-4.874A4.887,4.887,0,0,0,1411.252,1057.062Zm0-1.978a2.884,2.884,0,1,1,2.858-2.9A2.9,2.9,0,0,1,1411.252,1055.085Z"
            transform="translate(-1393.1 -1034.05)"
            fill="#fff"
          />
        </g>
      </g>
    </svg>
  );
};
